




























import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class versionSpecsPanel extends Vue {
    public $refs: {
    };

    show = false;

    @Prop({
        type:Object,
        default:()=>{
            return{
                id:"",
                versionType:null,
                minimumVersion:'',
                latestVersion:'',
                versionInfo:'',
                url:'',
            }
        }
    })
    form:any;

    @Prop({
        default:false
    })
    isMust:Boolean;
        
    created() {
    }
    mounted() {
    }

    showFun(list){
        this.show = true;
     
    }

    closeFun(){
        this.show = false;
    }
    goUpdate(){
        // this.closeFun();
        // window.open('https://apps.apple.com/app/%E8%88%AA%E5%AF%8C%E9%80%9A/id6449144766', '_blank');
        window.webkit.messageHandlers.upDate.postMessage(this.form.url);
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/versionSpecsPanel.vue